import React from 'react';
import loadable from '@loadable/component';
import {ErrorBoundary} from 'components/__helpers/errorBoundary/errorBoundary';

/**
 * Function for import lazy component
 * @param {Function} importModule - import function
 * @param {string} exportedName - exported name module
 * @param {object} suspenseProps - props to suspense component
 * @return {React.FC} - lazy component
 */
export const dynamic = (
    importModule: () => Promise<any>,
    exportedName = 'default',
    suspenseProps: {fallback: typeof loadable.fallback} = {fallback: null},
): React.FC<any> => {
    const Component = loadable(importModule, {
        resolveComponent: components => components[exportedName],
        fallback: suspenseProps.fallback,
    });

    return React.memo(props => (
        <ErrorBoundary fallback={suspenseProps.fallback}>
            <Component {...props} />
        </ErrorBoundary>
    ));
};
